import React, { useContext } from "react";
import PropTypes from "prop-types";

// Components
import Link from "../Atoms/Link";
import Image from "../Atoms/Image";

// Utils
import { TrackingContext } from "../Utils/TrackingWrapper";

// Stylesheets
import "./AppStoreBadges.scss";

// Constants
import { IMGIX_BASE_PATH } from "../../utils/constants";

export const AppStoreBadges = ({
  showAppStoreBadge,
  showGooglePlayStoreBadge,
}) => {
  // GTM Track - App Download
  const {
    trackingActions: { trackAppDownload },
  } = useContext(TrackingContext);

  const renderAppStoreBadge = (showBadge) => {
    if (showBadge) {
      return (
        <li className="app_store_wrapper link_wrapper">
          <Link
            href="https://apps.apple.com/us/app/hatch-baby-rest/id1158048301"
            className="app_badge_link"
            onClick={() => trackAppDownload({ app_platform: "apple" })}
          >
            <Image
              className="apple_app_store_badge app_store_badge"
              loading="lazy"
              src={`${IMGIX_BASE_PATH}/Apple-app-store-badge-black.svg`}
              alt="Apple App Store Badge"
            />
          </Link>
        </li>
      );
    }

    return null;
  };
  const renderGooglePlayStoreBadge = (showBadge) => {
    if (showBadge) {
      return (
        <li className="google_play_store_wrapper link_wrapper">
          <Link
            href="https://play.google.com/store/apps/details?id=com.hatchbaby.rest&hl=en_US"
            className="app_badge_link"
            onClick={() => trackAppDownload({ app_platform: "google" })}
          >
            <Image
              className="google_play_store app_store_badge"
              loading="lazy"
              src={`${IMGIX_BASE_PATH}/google-play-badge-black.svg`}
              alt="Google Play Store Badge"
            />
          </Link>
        </li>
      );
    }

    return null;
  };

  return (
    <ul className="app_store_badge_links unstyled_list">
      {renderAppStoreBadge(showAppStoreBadge)}

      {renderGooglePlayStoreBadge(showGooglePlayStoreBadge)}
    </ul>
  );
};

AppStoreBadges.propTypes = {
  showAppStoreBadge: PropTypes.bool,
  showGooglePlayStoreBadge: PropTypes.bool,
};

AppStoreBadges.defaultProps = {
  showAppStoreBadge: true,
  showGooglePlayStoreBadge: true,
};

export default AppStoreBadges;
